// Vendor imports
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const morePropTypes = require('client-v2/common/utils/prop-types')

const bem = BemEntity('Button')

function Button({ forwardedRef: ref, children, ...props }) {
  const { as, ...derivedProps } = derivedButtonProps(props)
  return tag(as, {
    ref,
    ...props,
    ...derivedProps,
    className: classNames(
      props.className,
      bem.block({
        disabled: derivedProps.disabled
      })
    )
  },
    children
  )
}

Button.propTypes = {
  // Values
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  forwardedRef: morePropTypes.domRef,
  href: PropTypes.string,
  rel: PropTypes.string,
  target: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  // Callbacks
  onClick: PropTypes.func
}

Button.withButton = className => {
  const highOrderComponent = props => {
    return tag(Button, {
      ...props,
      className: classNames(className, props.className)
    })
  }
  highOrderComponent.displayName = `withButton(${className})`
  highOrderComponent.propTypes = Button.propTypes
  return highOrderComponent
}

module.exports = Button

function derivedButtonProps(props) {
  if (props.href && !props.disabled) {
    return {
      as: 'a',
      href: props.href,
      rel: props.rel,
      target: props.target
    }
  }
  return {
    as: 'button',
    type: props.type || 'button',
    disabled: !!props.disabled
  }
}
